import React, { Component } from 'react'
import pin from '../images/lokal/pin-white.png'
import $ from "jquery";
import { getData } from '../services';
import { withRouter } from 'react-router-dom'; 
class StartShopping extends Component {
  constructor(props) {
    super(props)
    this.state = {
      locationDetails: [],
      locationDetailsCopy: [],
      textLocation: '',
      locationId: '',
      cityDetails: [],
      textCity: '',
      cityId: ''
    }
    this.goClick = this.goClick.bind(this)
    this.handleLocationClick = this.handleLocationClick.bind(this)
    this.checkStoreInLocationHome = this.checkStoreInLocationHome.bind(this)
    this.handleCityClick = this.handleCityClick.bind(this)
  }
  componentDidMount() {
    this.fetchLocationDetails()
    $(document).mouseup(function (e) {
      var serachContainer = $("#locationSearchHome");
      if (!serachContainer.is(e.target) // if the target of the click isn't the container...
        && serachContainer.has(e.target).length === 0) // ... nor a descendant of the container
      {
        serachContainer.hide();
      }
    });
  }
  fetchCityDetails() {
    let myCategoryId = window.sessionStorage.getItem('siteCategoryId');
    var key = $("#txtCityHome").val();
    const postData = {
      functionName: "lokal/cityList",
      myCategoryId: myCategoryId,
      cityKeyWord: key
    }
    getData(postData).then((data) => {
      if (data.data.success === "1") {
        this.setState({
          cityDetails: data.data.result.cityDetails
        });
      }
      else {
        $("#citySearchHome").hide();
        this.setState({
          cityDetails: []
        });
      }
    });
  }

  fetchLocationDetails() {
    {console.log("zzzzzzzzzzzzzzzzzzzzzzzzzzzzz",window.sessionStorage.getItem('sellerId'))}
    let myCategoryId = window.sessionStorage.getItem('siteCategoryId');
    var key = $("#txtLocationHome").val();
    let sellerId = window.sessionStorage.getItem('sellerId');
    let cityId = '';
    const postData = {
      functionName: "lokal/locationList",
      myCategoryId: myCategoryId,
      cityId: cityId,
      locationKeyword: key,
      storeId: '',
      sellerId: (sellerId === "null" ? '' : sellerId),
    }
    getData(postData).then((data) => {
      if (data.data.success === "1") {
        this.setState({
          locationDetails: data.data.result.locationDetails,
          locationDetailsCopy: data.data.result.locationDetails
        });
      }
      else {
        $("#locationSearchHome").hide();
        this.setState({
          locationDetails: [],
          locationDetailsCopy: []
        });
      }
      $(".locationClear").show();
    });
  }

  startWithIgnoringCase(text, other) {
    return (text.toLowerCase().includes(other.toLowerCase()))
  }

  onLocationTextChanged = (e) => {
    $("#locationSearchHome").show();
    let filterbusiness;
    if (e.target.value === "") {
      filterbusiness = this.state.locationDetailsCopy
    }
    else {
      filterbusiness = this.state.locationDetailsCopy.filter((x) => {
        return this.startWithIgnoringCase(x.locationName, e.target.value);
      });
    }
    this.setState({
      locationDetails: filterbusiness
    });
  }
  onCityTextChanged = (e) => {
    $("#citySearchHome").show();
    this.fetchCityDetails()
  }
  suggestionCitySelected(cityId, cityName) {
    $("#citySearchHome").hide();
    $("#txtCityHome").val(cityName)
    $("#hidCityIdHome").val(cityId)
    localStorage.setItem('locationId', "");
    localStorage.setItem('locationText', "");
    this.fetchLocationDetails()
  }
  suggestionLocationSelected(value, locationId, cityId, cityName, city, locationNameOnly) {
    $("#txtLocationHome").val(value)
    localStorage.setItem('cityId', cityId);
    localStorage.setItem('cityText', cityName);
    localStorage.setItem('cityNameOnly', city);
    localStorage.setItem('locationNameOnly', locationNameOnly);
    this.setState({
      textLocation: value,
      locationId: locationId
    }, () => {
      this.checkStoreInLocationHome()
    });
  }
  removeCartItems(storeIds) {
    var storeIdSpit = storeIds.split(',')
    for (var s = 0; s < storeIdSpit.length; s++) {
      var storeId = storeIdSpit[s]
      var selectGroceryItemCart = JSON.parse(localStorage.getItem('selectedCartProduct')) || []
      var cookieNewGroceryItemValue = []
      var j = 0
      for (var i = 0; i < selectGroceryItemCart.length; i++) {
        if (storeId.toString() !== selectGroceryItemCart[i].storeId.toString()) {
          cookieNewGroceryItemValue[j] =
          {
            storeId: selectGroceryItemCart[i].storeId.toString().trim(),
            item_names: selectGroceryItemCart[i].item_names.toString().trim(),
            item_ids: selectGroceryItemCart[i].item_ids.toString().trim(),
            quantity: selectGroceryItemCart[i].quantity.toString().trim(),
            item_prices: selectGroceryItemCart[i].item_prices.toString().trim(),
            store_item_stock_ids: selectGroceryItemCart[i].store_item_stock_ids.toString().trim(),
            pack_ids: selectGroceryItemCart[i].pack_ids.toString().trim(),
            stock_quantity: selectGroceryItemCart[i].stock_quantity.toString().trim(),
            item_image: selectGroceryItemCart[i].item_image.toString().trim(),
            itemNo: selectGroceryItemCart[i].itemNo.toString().trim()
          }
          j = parseInt(j) + 1
        }
      }
      localStorage.setItem('selectedCartProduct', JSON.stringify(cookieNewGroceryItemValue))
      var selectCommonItemCart = JSON.parse(localStorage.getItem('selectCommonItemCart')) || []
      var cookieNewCommonItemValue = []
      j = 0
      for (var i = 0; i < selectCommonItemCart.length; i++) {
        if (storeId.toString() !== selectCommonItemCart[i].storeId.toString()) {
          cookieNewCommonItemValue[j] =
          {
            storeId: selectCommonItemCart[i].storeId.toString().trim(),
            itemId: selectCommonItemCart[i].itemId.toString().trim(),
            itemName: selectCommonItemCart[i].itemName.toString().trim(),
            quantity: selectCommonItemCart[i].quantity.toString().trim(),
            itemTitle: selectCommonItemCart[i].itemTitle.toString().trim(),
            brand: selectCommonItemCart[i].brand.toString().trim(),
            sizeName: selectCommonItemCart[i].sizeName.toString().trim(),
            sizeId: selectCommonItemCart[i].sizeId.toString().trim(),
            cmItemSizeId: selectCommonItemCart[i].cmItemSizeId.toString().trim(),
            itemMasterId: selectCommonItemCart[i].itemMasterId.toString().trim(),
            netAmount: selectCommonItemCart[i].netAmount.toString().trim(),
            mrp: selectCommonItemCart[i].mrp.toString().trim(),
            itemImage: selectCommonItemCart[i].itemImage.toString().trim(),
            itemNo: selectCommonItemCart[i].itemNo.toString().trim()
          }
          j = parseInt(j) + 1
        }
      }
      localStorage.setItem('selectCommonItemCart', JSON.stringify(cookieNewCommonItemValue))
      var selectRestaurantCart = JSON.parse(localStorage.getItem('selectRestaurantCart')) || []
      var cookieNewRestaurantValue = []
      j = 0
      for (var i = 0; i < selectRestaurantCart.length; i++) {
        if (storeId.toString() !== selectRestaurantCart[i].storeId.toString()) {
          cookieNewRestaurantValue[j] =
          {
            storeId: selectRestaurantCart[i].storeId.toString().trim(),
            itemId: selectRestaurantCart[i].itemId.toString().trim(),
            itemName: selectRestaurantCart[i].itemName.toString().trim(),
            quantity: selectRestaurantCart[i].quantity.toString().trim(),
            itemSize: selectRestaurantCart[i].itemSize.toString().trim(),
            itemMrp: selectRestaurantCart[i].itemMrp.toString().trim(),
            itemImage: selectRestaurantCart[i].itemImage.toString().trim(),
            storeItemSizeId: selectRestaurantCart[i].storeItemSizeId.toString().trim(),
            itemNo: selectRestaurantCart[i].itemNo.toString().trim(),
            toppingsData: selectRestaurantCart[i].toppingsData.toString().trim()
          }
          j = parseInt(j) + 1
        }
      }
      localStorage.setItem('selectRestaurantCart', JSON.stringify(cookieNewRestaurantValue))
    }
  }
  checkStoreInLocationHome() {
    var storeId = []
    var selectGroceryItemCart = JSON.parse(localStorage.getItem('selectedCartProduct')) || []
    for (var i = 0; i < selectGroceryItemCart.length; i++) {
      storeId.push(selectGroceryItemCart[i].storeId)
    }
    var selectCommonItemCart = JSON.parse(localStorage.getItem('selectCommonItemCart')) || []
    for (var i = 0; i < selectCommonItemCart.length; i++) {
      storeId.push(selectCommonItemCart[i].storeId)
    }
    var selectRestaurantCart = JSON.parse(localStorage.getItem('selectRestaurantCart')) || []
    for (var i = 0; i < selectRestaurantCart.length; i++) {
      storeId.push(selectRestaurantCart[i].storeId)
    }
    if (storeId.length > 0) {
      var storeIdSplit = storeId.toString().replace(/[\[\]']+/g, '')
      const postData = {
        "functionName": "lokal/storeLocation",
        "storeId": storeIdSplit,
        "locationId": $("#hidLocationIdHome").val()
      }
      getData(postData).then((data) => {
        console.log("data1", data)
        if (data.data.success === "1") {
          if (data.data.result.cartClearFlag === "1") {
            var a = window.confirm(data.data.result.message)
            if (a) {
              this.removeCartItems(data.data.result.storeIds);
              this.goClick();
            }
            else {
              $("#txtLocation").val('');
              $(".locationClear").hide();
            }
          }
          else {
            this.goClick();
          }
        }
      })
    }
    else {
      this.goClick();
    }
  }
  categorySelection(){
    let locationId = '';
    if (this.props.fromPage !== 'lokalHome') {
        locationId = localStorage.getItem('locationId');
    }
    const postData = {
      "functionName": "lokal/category",
      "myCategoryId": window.sessionStorage.getItem('siteCategoryId'),
      "locationId": locationId
  }

  getData(postData).then((data) => {
      console.log("categorydata ", data)
      if (data.data.success === "1") {
          if (data.data.result.category.length === 1) {
            const obj = data.data.result.category[0];
              window.sessionStorage.setItem('mainCategoryIdLokal', obj.id)
              window.sessionStorage.setItem('mainCategoryId', obj.id)
              window.sessionStorage.setItem('storeName', '')
              window.sessionStorage.setItem('storeId', '')
              window.sessionStorage.setItem('mainCategoryAlternativeName', obj.alternativeName)
              localStorage.removeItem('cityId');
              localStorage.removeItem('cityText');
              localStorage.removeItem('cityNameOnly');
              localStorage.removeItem('locationNameOnly');
              localStorage.removeItem('locationId');
          localStorage.removeItem('locationText');
              this.setCategorySessions(obj, 'hasLocation')
          }
          else {
            localStorage.removeItem('cityId');
            localStorage.removeItem('cityText');
            localStorage.removeItem('cityNameOnly');
            localStorage.removeItem('locationNameOnly');
            localStorage.removeItem('locationId');
            localStorage.removeItem('locationText');
            window.location.href = "/category";
          }
      }
      else {
          this.setState({
              isData: '0'
          });
      }
  });
  }
  setCategorySessions(obj, flag) {
    const { history } = this.props;
    let title = obj.seoTitle.replace('{{SiteName}}', window.sessionStorage.getItem('siteName')).replace('{{Location}}', "anywhere")
    let description = obj.seoDescription.replace('{{SiteName}}', window.sessionStorage.getItem('siteName')).replace('{{Location}}', "anywhere")
    let slug = obj.seoSlug.replace('{{City}}',"anywhere").replace('{{Location}}', "anywhere")
    let h1 = obj.seoH1.replace('{{Location}}', "anywhere")
    if(localStorage.getItem('siteGlobalDelivery') === "false" && localStorage.getItem('isPincodeBased') === "false"){
     title = obj.seoTitle.replace('{{SiteName}}', window.sessionStorage.getItem('siteName')).replace('{{Location}}', localStorage.getItem('locationNameOnly'))
     description = obj.seoDescription.replace('{{SiteName}}', window.sessionStorage.getItem('siteName')).replace('{{Location}}', localStorage.getItem('locationNameOnly'))
    slug = obj.seoSlug.replace('{{City}}', localStorage.getItem('cityNameOnly').toLowerCase()).replace('{{Location}}', localStorage.getItem('locationNameOnly').toLowerCase().trim().replace(/ /g, '-'))
     h1 = obj.seoH1.replace('{{Location}}', localStorage.getItem('locationNameOnly'))
    }
    window.sessionStorage.setItem('mainCategorySeoTitle', title)
    window.sessionStorage.setItem('mainCategorySeoDescription', description)
    window.sessionStorage.setItem('mainCategorySeoSlug', slug)
    window.sessionStorage.setItem('mainCategorySeoH1', h1)
  if (localStorage.getItem('hasGlobalSearch') == "true") {
      history.push("/globalSearchResult", { searchKey: "dental", mode: '' });
    }
    else if (flag === "hasLocation") {
        window.location.href = slug
    }
}
  goClick() {
    let themeId = localStorage.getItem('themeId')
   if (themeId === '34' || themeId === '29'|| themeId === '4') {
            this.categorySelection() 
    }
  }
  locationClose() {
    $("#txtLocationHome").val('');
    $(".locationClear").hide();
  }
  handleLocationClick() {
    $("#locationSearchHome").show();
  }
  handleCityClick() {
    $("#citySearchHome").show();
    this.fetchCityDetails()
  }
  render() {
    const { textLocation } = this.state;
    const { locationId } = this.state;
    if (textLocation == "") {
      this.state.locationId = "";
    }
    let displayCity = window.sessionStorage.getItem('displayCity')
    return (
      <div>
        <span onClick={this.goClick} className="bannerButton">Continue without PinCode</span>
      </div>
    )
  }
}
export default withRouter(StartShopping);